import { render } from "./SelectorWidget.vue?vue&type=template&id=3db07c3a&scoped=true"
import script from "./SelectorWidget.vue?vue&type=script&lang=js"
export * from "./SelectorWidget.vue?vue&type=script&lang=js"

import "./SelectorWidget.vue?vue&type=style&index=0&id=3db07c3a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lv2353\\workspace\\5160-ited\\collection-page\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3db07c3a"]])

export default __exports__